import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import { getPaginatedOrders } from "services/orders.service";
import Breadcrumbs from "components/Common/Breadcrumb";
import Spinner from "components/spinner";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import { MetaTags } from "react-meta-tags";
import {
  getConsultationOrderDetailsByOrderId,
  getConsultationOrdersByStatus,
  getConsultationOrdersCounts,
  getOrderBySearch,
} from "services/V2_APIs/consultationOrders.service";
import ConsultationOrdersListPage from "./list";
import ConsultationOrderDetailsPage from "./detailsPage";
// import HotelOrdeDetailsPage from "./HotelOrdeDetailsPage";
const ConsultationOrderPage = () => {
  const [loading, setLoading] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [counts, setCounts] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [defaultTab, setDefaultTab] = useState("1");
  const [defaultOrders, setDefaultOrders] = useState([]);
  const [displayOrders, setDisplayOrders] = useState([]);
  const [activeOrder, setActiveOrder] = useState(null);
  const [completedStatusCount, setCompletedStatusCount] = useState(0);
  const [paidStatusCount, setPaidStatusCount] = useState(0);
  const [acceptedStatusCount, setAcceptedStatusCount] = useState(0);
  const [pendingStatusCount, setPendingStatusCount] = useState(0);
  const [cancelledStatusCount, setCancelledStatusCount] = useState(0);
  const [inProgressStatusCount, setInProgressStatusCount] = useState(0);
  // const [notAvailableStatusCount, setNotAvailableStatusCount] = useState(0);
  const [todaysOrdersCount, setTodaysOrdersCount] = useState(0);
  const [allOrdersCount, setAllOrdersCount] = useState(0);
  // const [pastPendingOrders, setPastPendingOrders] = useState(0);
  // const [pastPendingOrdersTab, setPastPendingOrdersTab] = useState(false);
  const [nextUrl, setNextUrl] = useState("");
  const [loadMore, setLoadMore] = useState(false);

  useEffect(() => {
    getAllOrdersList();
  }, []);

  useEffect(() => {
    FilterByStatus();
  }, [counts]);
  const handleSearch = _.debounce(input => {
    setLoading(true);
    if (input.length !== 0) {
      getOrderBySearch(input)
        .then(res => {
          setDisplayOrders(res?.data);
          setActiveTab(null);
          setActiveOrder(null);
          setSearchInput(input);
          if (res?.data.length < 10) {
            setLoadMore(false);
          } else {
            setNextUrl(res?.meta?.nextUrl);
            setLoadMore(true);
          }
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
        });
    } else {
      setTimeout(() => {
        setSearchInput(input);
        setActiveTab(defaultTab);
        setDisplayOrders(defaultOrders);
        setActiveOrder(null);
        setLoading(false);
      }, 500);
    }
  }, 2000);
  const getAllOrdersList = () => {
    setLoading(true);
    let ordersPromise;
    ordersPromise = getConsultationOrdersCounts();
    ordersPromise
      .then(res => {
        if (res?.data) {
          if (res?.data?.counts?.length === 0) {
            setAcceptedStatusCount(0);
            // setNotAvailableStatusCount(0);
            setPendingStatusCount(0);
            setInProgressStatusCount(0);
            setCompletedStatusCount(0);
            setPaidStatusCount(0);
            setCancelledStatusCount(0);
            setAllOrdersCount(0);
            setTodaysOrdersCount(0);
            setCounts([]);
            setDisplayOrders(
              res?.data?.orders?.length ? res?.data?.orders : []
            );
            setDefaultOrders(
              res?.data?.orders?.length ? res?.data?.orders : []
            );
          } else {
            setDisplayOrders(res?.data?.orders);
            setDefaultOrders(res?.data?.orders);
            setSearchInput("");
            setSearchValue("");
            setActiveTab("1");
            setDefaultTab("1");
            setCounts(res?.data?.counts);
            setTodaysOrdersCount(res?.meta?.count);
          }
          if (res?.data?.orders.length < 10) {
            setLoadMore(false);
          } else {
            setNextUrl(res?.meta?.nextUrl);
            setLoadMore(true);
          }
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err); // Log the error for debugging
        setLoading(false);
      });
  };

  const GetOrdersByTab = status => {
    setLoading(true);
    let getOrderByStatus;
    // Assign the promise based on the condition
    getOrderByStatus = getConsultationOrdersByStatus(status);
    getOrderByStatus
      .then(res => {
        setDisplayOrders(res?.data);
        setDefaultOrders(res?.data);
        if (res?.data.length < 10) {
          setLoadMore(false);
        } else {
          setNextUrl(res?.meta?.nextUrl);
          setLoadMore(true);
        }
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
      });
  };
  const getOrderDetailsByID = id => {
    setLoading(true);
    getConsultationOrderDetailsByOrderId(id)
      .then(res => {
        let resp = res?.data[0] || [];
        setActiveOrder(resp);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
      });
  };

  const handleActiveTab = (tab, status) => {
    setActiveTab(tab);
    setDefaultTab(tab);
    setSearchInput("");
    setSearchValue("");
    GetOrdersByTab(status);
    setActiveOrder(null);
  };
  const handleActiveOrder = order => {
    getOrderDetailsByID(order?._id);
  };

  const handleScroll = _.debounce(() => {
    setLoading(true);
    getPaginatedOrders(nextUrl)
      .then(res => {
        setDisplayOrders([...displayOrders, ...res?.data]);
        setDefaultOrders([...defaultOrders, ...res?.data]);
        if (res?.data.length < 10) {
          setLoadMore(false);
        } else {
          setNextUrl(res?.meta?.nextUrl);
          setLoadMore(true);
        }
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
      });
  }, 500);

  const FilterByStatus = () => {
    if (counts?.length !== 0) {
      let AcceptedStatus = counts?.filter(ele => ele?._id === "Confirmed");
      let TotalAcceptedStatusCount = AcceptedStatus[0] // total count
        ? AcceptedStatus[0]?.statusCount
        : 0;
      let ConfirmedOrdersCount =
        AcceptedStatus[0] && AcceptedStatus[0]?.statusCount
          ? AcceptedStatus[0].statusCount
          : 0;
      let PendingStatus = counts?.filter(ele => ele?._id === "Pending");
      let PendingStatusCount = PendingStatus[0]
        ? PendingStatus[0]?.statusCount
        : 0;
      // In Progress Status - Orders in progress
      let InprogressStatus = counts?.filter(
        ele => ele?._id === "In Progress" || ele?._id === "InProgress"
      );

      let InProgressStatusCount = InprogressStatus[0]
        ? InprogressStatus[0]?.statusCount
        : 0;
      // Completed Status - Order Service Completed, but no payment yet
      let CompletedStatus = counts?.filter(ele => ele?._id === "Completed");
      let CompletedStatusCount = CompletedStatus[0]
        ? CompletedStatus[0]?.statusCount
        : 0;
      // Paid Status - Order officially completed with payment confirmed
      let PaidStatus = counts?.filter(ele => ele?._id === "Paid");
      let PaidStatusCount = PaidStatus[0] ? PaidStatus[0]?.statusCount : 0;
      // Cancelled Status - Order cancelled, mostly from user side
      let CancelledStatus = counts?.filter(
        ele => ele?._id === "cancel" || ele?._id === "Cancelled"
      );
      let CancelledStatusCount = CancelledStatus[0]
        ? CancelledStatus[0]?.statusCount
        : 0;
      // Total Order Count
      let allOrders =
        TotalAcceptedStatusCount +
        InProgressStatusCount +
        CompletedStatusCount +
        PaidStatusCount +
        CancelledStatusCount;
      setAcceptedStatusCount(ConfirmedOrdersCount);
      setPendingStatusCount(PendingStatusCount);
      setInProgressStatusCount(InProgressStatusCount);
      setCompletedStatusCount(CompletedStatusCount);
      setPaidStatusCount(PaidStatusCount);
      setCancelledStatusCount(CancelledStatusCount);
      setAllOrdersCount(allOrders);
    }
  };
  const statusClassMap = {
    1: "bg-today",
    2: "bg-pending",
    3: "bg-secondary",
    4: "bg-warning",
    5: "bg-success",
    6: "bg-info",
    7: "bg-danger",
    8: "bg-primary",
    // 9: "bg-red",
    // 10: "bg-past-pending",
  };
  const tabs = [
    { id: "1", title: "Today", subTitle: "today", count: todaysOrdersCount },
    {
      id: "2",
      title: "Pending",
      subTitle: "Pending",
      count: pendingStatusCount,
    },
    {
      id: "3",
      title: "Confirmed",
      subTitle: "Confirmed",
      count: acceptedStatusCount,
    },
    {
      id: "4",
      title: "In Progress",
      subTitle: "InProgress",
      count: inProgressStatusCount,
    },
    {
      id: "5",
      title: "completed",
      subTitle: "Completed",
      count: completedStatusCount,
    },
    { id: "6", title: "Paid", subTitle: "Paid", count: paidStatusCount },
    {
      id: "7",
      title: "Cancelled",
      subTitle: "Cancelled",
      count: cancelledStatusCount,
    },
    // { id: "8", title: "All Orders", subTitle: "all", count: allOrdersCount },
    // {
    //   id: "9",
    //   title: "Stylist not available",
    //   subTitle: "notAvailable",
    //   count: notAvailableStatusCount,
    // },
    // {
    //   id: "10",
    //   title: "Pending past orders",
    //   subTitle: "pastPending",
    //   count: pastPendingOrders,
    // },
  ];
  return (
    <React.Fragment>
      <Spinner loading={loading} />
      <div className="page-content">
        <MetaTags>
          <title></title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Orders" breadcrumbItem="Orders List" />
          <BreadcrumbSub
            subtile="Consultation orders"
            SubBreadcrumbItem="Orders"
          />
          <div>
            <div className="tabs order-dashboard">
              <Nav tabs>
                <NavItem className="d-flex justify-content-space-between flex-wrap">
                  {tabs.map(tab => (
                    <NavLink
                      key={tab.id}
                      className={
                        tab?.title === "Stylist not available"
                          ? "stylist_not_available"
                          : tab?.title === "Pending past orders"
                          ? "pending_past_orders"
                          : ""
                      }
                    >
                      <CardBody
                        className={`shadow-sm rounded ${
                          statusClassMap[tab.id]
                        }`}
                        onClick={() => {
                          handleActiveTab(tab?.id, tab?.subTitle);
                        }}
                      >
                        <div className="text-center">
                          <h6 className="pt-2">{tab?.title}</h6>
                          <h2>{tab?.count}</h2>
                          {activeTab === tab?.id && (
                            <div className="check_mark">
                              <i className="bx bx-check-circle"></i>
                            </div>
                          )}
                        </div>
                      </CardBody>
                    </NavLink>
                  ))}
                </NavItem>
              </Nav>
            </div>
            <Row className="mt-3">
              <Col md="4">
                <Card>
                  <CardBody className="p-2">
                    <div className="search-box  position-relative w-100 ">
                      <i className="bx bx-search-alt search-icon" />
                      <input
                        className="form-control  rounded-pill bg-white "
                        type="search"
                        id="example-search-input"
                        placeholder=" Search..."
                        onChange={e => handleSearch(e.target.value)}
                      />
                    </div>
                    {searchInput.length !== 0 ? (
                      <span
                        role="button"
                        className="font-size-12 badge-soft-info py-1 px-2 me-1 fw-bold badge bg-bg-info search-input"
                      >
                        <span className="font-size-12">Search: </span>
                        <span className="font-size-12 fw-bold text-dark">
                          <span className="ps-1 text-dark pt-1">
                            {searchInput}
                          </span>
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </CardBody>
                  <ConsultationOrdersListPage
                    handleActiveOrder={handleActiveOrder}
                    handleScroll={handleScroll}
                    displayOrders={displayOrders}
                    loadMore={loadMore}
                    activeOrder={activeOrder}
                    // getallOrders={getAllOrdersList}
                    // reload={handleActiveOrder}
                  />
                </Card>
              </Col>
              <Col md="8" className="Order_details_page">
                <ConsultationOrderDetailsPage
                  activeOrder={activeOrder}
                  // reload={handleActiveOrder}
                  handleActiveOrder={handleActiveOrder}
                  getAllOrdersList={getAllOrdersList}
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConsultationOrderPage;
